

export const Footer = () => {

  return (
    <>
      <footer className="footer">
          <div className="container-fluid">
              <div className="row">
                  <div className="col-sm-6">
                  <span>{(new Date().getFullYear())}</span> © ZPC Shehia Register.
                  </div>
                  <div className="col-sm-6">
                      <div className="text-sm-end d-none d-sm-block">
                          Design & Develop by <a className="fw-bolder text-success" target={'_blank'} href="https://suza.ac.tz">SUZA</a>
                      </div>
                  </div>
              </div>
          </div>
      </footer>
    </>
  )

}